import React, { FC } from 'react';
import { PageType } from '../../../../../../config/api/models/Trajectory';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { Block } from '../../../../../../config/api/models/Block';
import BlocksListItem from './BlocksListItem';
import { useTranslation } from 'react-i18next';
import { usePagesByType } from '../../../../hooks';
import { useAppSelector } from '../../../../../shared/hooks/useAppDispatch';
import { styled, Theme } from '@material-ui/core';

type Props = {
  pageType: PageType;
  bookId: string;
  onOrderBlocks: ({ source, destination }: DropResult) => void;
  trajectoryId?: string;
};

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const NoBlocksMessage = styled('div')<Theme>(({ theme }) => ({
  fontSize: theme.typography.h4.fontSize,
  fontStyle: 'italic',
  color: theme.palette.grey['600'],
}));

const BlocksList: FC<Props> = ({ pageType, bookId, onOrderBlocks, trajectoryId }) => {
  const { t } = useTranslation();
  const page = usePagesByType(pageType);
  const blocks = useAppSelector((state) => state.blocks.blocks);

  return page.data && page.data.length > 0 ? (
    <Wrapper>
      {blocks && blocks.length > 0 ? (
        <DragDropContext onDragEnd={onOrderBlocks}>
          <Droppable droppableId="ROOT">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {blocks &&
                  blocks.map((block: Block, index: number) => (
                    <Draggable key={block.id} draggableId={block.id} index={index}>
                      {({ draggableProps, dragHandleProps, innerRef }) => (
                        <div ref={innerRef} {...draggableProps}>
                          <BlocksListItem
                            page={page.data && page.data[0]}
                            block={block}
                            bookId={bookId}
                            dragHandleProps={dragHandleProps || undefined}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        <NoBlocksMessage>{t('trajectory.sidebar.pageManagement.noBlocks')}</NoBlocksMessage>
      )}
    </Wrapper>
  ) : null;
};

export default BlocksList;
